module.exports = __webpack_public_path__ + "media/images/pc/top/area_brand_sola@2x-45bd9d4c27dd0e82a412f106effa3133.webp";